import React from 'react';

const CompanyTitle = ({ record }) => {
	return <span>Company {record ? `"${record.name}"` : ''}</span>;
};

export default CompanyTitle;
